import React from 'react';
import Icon from '../../../components/AppIcon';
import { motion } from 'framer-motion';

const DashboardSidebar = ({ activeSection, setActiveSection, sidebarOpen, setSidebarOpen }) => {
  const sidebarItems = [
    {
      key: 'profile',
      label: 'Profile',
      icon: 'User',
      description: 'Manage your profile'
    },
    {
      key: 'preferences',
      label: 'Preferences',
      icon: 'Settings',
      description: 'Budget & interests'
    },
    {
      key: 'checklist',
      label: 'Checklist',
      icon: 'CheckSquare',
      description: 'Wedding tasks'
    },
    {
      key: 'vendors',
      label: 'Vendors',
      icon: 'Building',
      description: 'Saved vendors'
    },
    {
      key: 'messages',
      label: 'Messages',
      icon: 'MessageCircle',
      description: 'Communications'
    },
    {
      key: 'registry',
      label: 'Registry',
      icon: 'Gift',
      description: 'Gift registry'
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: 'Settings',
      description: 'Account settings'
    }
  ];

  const handleItemClick = (key) => {
    setActiveSection(key);
    setSidebarOpen(false);
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:block fixed left-0 top-16 bottom-0 w-64 bg-surface border-r border-border overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center space-x-3 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-primary to-primary-600 rounded-full flex items-center justify-center">
              <Icon name="User" size={24} color="white" />
            </div>
            <div>
              <h2 className="font-semibold text-text-primary">Welcome back!</h2>
              <p className="text-sm text-text-muted">Manage your wedding</p>
            </div>
          </div>

          <nav className="space-y-2">
            {sidebarItems.map((item) => (
              <button
                key={item.key}
                onClick={() => handleItemClick(item.key)}
                className={`w-full flex items-center space-x-3 p-3 rounded-lg text-left transition-colors ${
                  activeSection === item.key
                    ? 'bg-primary-50 text-primary border border-primary-200' :'text-text-secondary hover:bg-surface-100 hover:text-primary'
                }`}
              >
                <Icon 
                  name={item.icon} 
                  size={20} 
                  color={activeSection === item.key ? '#8B1538' : 'currentColor'} 
                />
                <div className="flex-1 min-w-0">
                  <div className="font-medium">{item.label}</div>
                  <div className="text-xs text-text-muted truncate">{item.description}</div>
                </div>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <motion.div
        initial={false}
        animate={{
          x: sidebarOpen ? 0 : -280
        }}
        transition={{ type: 'tween', duration: 0.3 }}
        className="fixed left-0 top-16 bottom-0 w-64 bg-surface border-r border-border overflow-y-auto z-50 lg:hidden"
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-primary-600 rounded-full flex items-center justify-center">
                <Icon name="User" size={20} color="white" />
              </div>
              <div>
                <h2 className="font-semibold text-text-primary">Dashboard</h2>
                <p className="text-sm text-text-muted">Your wedding</p>
              </div>
            </div>
            <button
              onClick={() => setSidebarOpen(false)}
              className="p-2 rounded-lg hover:bg-surface-100 transition-colors"
            >
              <Icon name="X" size={18} />
            </button>
          </div>

          <nav className="space-y-2">
            {sidebarItems.map((item) => (
              <button
                key={item.key}
                onClick={() => handleItemClick(item.key)}
                className={`w-full flex items-center space-x-3 p-3 rounded-lg text-left transition-colors ${
                  activeSection === item.key
                    ? 'bg-primary-50 text-primary border border-primary-200' :'text-text-secondary hover:bg-surface-100 hover:text-primary'
                }`}
              >
                <Icon 
                  name={item.icon} 
                  size={20} 
                  color={activeSection === item.key ? '#8B1538' : 'currentColor'} 
                />
                <div className="flex-1 min-w-0">
                  <div className="font-medium">{item.label}</div>
                  <div className="text-xs text-text-muted truncate">{item.description}</div>
                </div>
              </button>
            ))}
          </nav>
        </div>
      </motion.div>
    </>
  );
};

export default DashboardSidebar;